import { get } from 'lodash';
// eslint-disable-next-line no-restricted-imports
import { Col } from 'react-bootstrap';
import React, { useRef } from 'react';
import { useTransition, animated as a } from 'react-spring';

import AddNew from './SearchResults/AddNew';
import People from './SearchResults/People';
import * as Ph from '~/App/Components/Placeholder';
import { Profile } from '~/types/models';

function SearchResultsLoading() {
  return (
    <Col md={12} style={{ width: '100%' }}>
      <Ph.Item>
        <Ph.Col size={12}>
          <Ph.Row>
            <Ph.Col size={2} />
          </Ph.Row>
          <Ph.Row>
            <Ph.Col size={12} />
          </Ph.Row>
          <Ph.Row>
            <Ph.Col size={2} />
          </Ph.Row>
          <Ph.Row>
            <Ph.Col size={12} />
          </Ph.Row>
          <Ph.Row>
            <Ph.Col size={2} />
          </Ph.Row>
          <Ph.Row>
            <Ph.Col size={12} />
            <Ph.Col size={12} />
            <Ph.Col size={12} />
            <Ph.Col size={12} />
          </Ph.Row>
        </Ph.Col>
      </Ph.Item>
    </Col>
  );
}

export type SearchResultsProps = {
  query: string;
  people: Profile[];
  isLoading: boolean;
  checkIfSelected: (key: string) => boolean;
  select: (id: string, name: string, profile: Profile) => void;
  deselect: (key: string, label: string, data: string) => void;
};

function SearchResults(props: SearchResultsProps) {
  const { query, people, isLoading, checkIfSelected, select, deselect } = props;

  const transitions = useTransition(isLoading, null, {
    from: { width: '100%', position: 'absolute', opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
  });

  const ref = useRef();

  return (
    <div
      style={{
        width: '100%',
        height: get(ref.current, 'clientHeight'),
        position: 'relative',
      }}
    >
      {transitions.map(({ key, item: loading, props }) => {
        return (
          <a.div key={key} ref={ref} style={props}>
            {loading ? (
              <SearchResultsLoading />
            ) : (
              <React.Fragment>
                <AddNew email={query} select={select} />
                <People
                  isSelected={checkIfSelected}
                  select={select}
                  deselect={deselect}
                  people={people}
                />
              </React.Fragment>
            )}
          </a.div>
        );
      })}
    </div>
  );
}

export default SearchResults;
